<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
	async mounted() {
		try {
			await this.$router.push("/list");
		}
		catch (e) {
			console.error("failed to goto /list", e);
		}
	}
};
</script>